import { ServiceProvider } from "@sa/rep-services-provider";
import { ServicesMaps } from '../MapReportingProvider';
import { MapStore } from '../store';
import { MapDataSource } from "../models/MapDataSource";
import { MapDimension } from "../models/MapDimension";
import { combineLatest, ReplaySubject, Subscription } from "rxjs";
import { debounceTime, filter, tap } from 'rxjs/operators';
import { clone } from "lodash";
import { MapDataExtractorProvider } from "../data/MapDataExtractorsProvider";


export class MapOLAPService {
  private _queryStream$ = new ReplaySubject<{
    dataSource: MapDataSource;
    dimensions: MapDimension[];
    values: Record<string, unknown[]>;
  }>(1);
  private _store: MapStore;

  constructor(serviceProvider: ServiceProvider) {
    this._store = serviceProvider.resolve(ServicesMaps.MapStore);
    const provider: MapDataExtractorProvider = serviceProvider.resolve(ServicesMaps.MapDataExtractorsProvider);

    this._queryStream$.pipe(
      tap(() =>this._store.loadingData$.next(true)),
      debounceTime(600)
    ).subscribe(async req => {
      if (req.dimensions.every(e => req.values[e.hierarchy]?.length)) {
        const extractor = provider.resolve(req.dataSource.id);
        const mapData = await extractor.fetchData(req.dataSource, req.dimensions, req.values);
        this._store.data$.next(mapData);
        this._store.loadingData$.next(false);
      }
    });
  }

  subscribe() {
    const subscriptions = { current: [] as Subscription[] };
    return combineLatest([this._store.dataSource$, this._store.dimensions$])
      .pipe(
        filter(([dataSource, dimensions]) => (dimensions as MapDimension[]).every(e => e.dataSource?.id === (dataSource as MapDataSource).id)),
      )
      .subscribe(([dataSource, dimensions]) => {
        if (subscriptions.current.length) {
          subscriptions.current.forEach(e => e.unsubscribe());
        }
        const valuesRecord: Record<string, unknown[]> = {};
        subscriptions.current = (dimensions as MapDimension[]).map(dim => {
          const stream$ = this._store.dimensionsValues.get(dim.id)!;
          return stream$.subscribe(value => {
            valuesRecord[dim.hierarchy] = [value].flat().filter(e => e !== null && e !== undefined);
            this._queryStream$.next({
              dataSource,
              dimensions,
              values: clone(valuesRecord),
            })
          });
        });
      });
  }
}